import React, { useState } from 'react'
import $ from "jquery";


const Logo = ({ data, ShowSidebar }) => {


  const [togglesidebar, settogglesidebar] = useState(false);

  const ShowSidebar123 = (event) => {
    if (event?.target.closest(".update-btn")) {
      return;
    }

    if (document.body.classList.toggle("sidebar-open")) {
      document.body.classList.remove("sidebar-remove");
    } else {
      document.body.classList.add("sidebar-remove");
    }

    settogglesidebar(!togglesidebar);
  };

  


    return (
        <div>
            <div className="nav-header d-flex align-items-center">
               

        <span className="brand-logo">
                    {togglesidebar ? 
                   <div> <img className="logo-abbr1" style={{width:"48px"}} src={data ? data : ""} alt="logo" />
                  </div> :
                     <img className="brand-title"  alt="logo" />}
             

                </span>
                <div className="nav-control toggle-sidebar-btn ms-lg-3"
                    //  onClick={ShowSidebar}
                    onClick={() => ShowSidebar123()}


                >
                    <div className="hamburger ">
                    <i className="fa-solid fa-bars "></i>
                        {/* <span className="line" />
                        <span className="line" />
                        <span className="line" /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Logo